(function($) {
  'use strict';
  const menu = $('<ol></ol>');

  $(document).ready(function() {
    $('.tour-right h2:not(.visually-hidden)').each(function(index,element) {
      //Do not show links to hidden webforms
      if($(element).parent().css('display') === "none") {
        return;
      }
      const titleID = 'jumpMenu-' + index;
      $(this).attr('id', titleID);
      menu.append('<li><a href="#' + titleID + '">' + $(this).text().trim() + '</a></li>');
    });
    $('#js-tour-menu').append(menu);
  });

  $('.tour-menu-trigger').on('click', function() {
    $(this).toggleClass('active');
    $('.tour-menu-block').toggleClass('open');
    $('body').toggleClass('no-scroll');
  });

  $('html').on('click', '.tour-menu-block a', function() {
    $('.tour-menu-block').removeClass('open');
    $('.tour-menu-trigger').removeClass('active');
    $('body').removeClass('no-scroll');
  });

  $('.show_gallery').on("click", (e) => {
    $(e.currentTarget).parent().find(".photoswipe-gallery .field--name-field-media > .field__item:first-child a").click();
  })



})(jQuery);
